import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type DatabaseMetadataFieldFragment = { name: string, type: Types.DatabaseFieldTypeEnum, fieldId: string, numberFormat?: Types.DatabaseNumberFormatEnum | null, dateFormat?: string | null, ratingType?: Types.DatabaseRatingTypeEnum | null, collectionType?: Types.DatabaseRelationCollectionTypeEnum | null, validation?: { maxValue?: number | null, maxLength?: number | null } | null, options?: Array<{ value: string, color: string, optionId: string }> | null };


export type DatabaseMetadataFieldFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const DatabaseMetadataFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseMetadataField on DatabaseMetadataFieldType {
  name
  type
  fieldId
  numberFormat
  dateFormat
  ratingType
  collectionType
  validation {
    maxValue
    maxLength
  }
  options {
    value
    color
    optionId
  }
}
    `;